import {includes} from "./Function";

export const CheckboxInput = ({label, onChange, toChange, metaData}) => {

    return (
        <label>
            <input type="checkbox" style={{height: "auto"}} checked={includes(metaData[toChange], label)}
                   onChange={() => onChange(label, toChange, !includes(metaData[toChange], label))}/>
            {label}
        </label>
    )
}